require.register("menu/video-3a-1-menu/video-3a-1-menu", function(exports, require, module){
  var BaseExtension = require('base-extension');
var _ = window._ || require('lodash');

var video3a1 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {
    let timerInterval,
        timeValue  = EF.courseTimerService.courseCountdownTimer.timeLeft;
    this.updateTimer(timeValue);
    if (EF.courseTimerService.courseCountdownTimer.state == "COMPLETED") {
      return;
    }
    timerInterval = setInterval(() => {
      timeValue = timeValue - 1;
      this.updateTimer(timeValue);
    },1000);
    view.subscribeEvent('enrollment-data-loaded:courseLevelTimer', (data) => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
      if (data.courseCountdownTimer.state == "COMPLETED" || $(".timer-heading > .list-text > p.description").text() == 0) {
        this.updateTimer(0);
        clearInterval(timerInterval);
        //window.location.reload();
      } else {
        timeValue = data.courseCountdownTimer.timeLeft;
        setTimeout(() => this.updateTimer(timeValue) ,0);
        timerInterval = setInterval(() => {
          timeValue = timeValue - 1;
          this.updateTimer(timeValue);
        },1000)
      }
    });
    $(window).blur(function(){
      clearInterval(timerInterval);
    });
    $(window).focus(() => {
      if(timerInterval){
        clearInterval(timerInterval);
      }
      timeValue = EF.courseTimerService.courseCountdownTimer.timeLeft;
      this.updateTimer(timeValue);
      timerInterval = setInterval(() => {
        timeValue = timeValue - 1;
        this.updateTimer(timeValue);
      }, 1000)
    });
  },
  updateTimer : function(time){
    if (time <=0)
      time = 0;
    $(".timer-heading > .list-text > p.description").text(this.timeConverter(time));
  },
  timeConverter: function(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    h = h < 10 ? ("0" + h) : h;
    m = m < 10 ? ("0" + m) : m;
    s = s < 10 ? ("0" + s) : s;
    return h + ":" + m + ":" + s; 
  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = video3a1;


  
});

